module.exports = __webpack_public_path__ + "c9ccffee81ff63b49f97db87c6b62810.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-05-05-harrison/diary.jpg
// module id = 1044
// module chunks = 0